/** @jsxImportSource @emotion/react */

import { Button, Grid, Snackbar, styled, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useContext, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MySnackbarContentWrapper from '../../Components/Snackbars';
import config from '../../config';
import getCookie, { deleteCookie, getToken, setCookie, setCookieNew, setTokens } from '../../Helper/Cookies/cookies';
import axios, { tokenReInitializer } from '../../Helper/Axios/interceptor';
import { addStageData } from '../../Helper/Redux/reducers/upDown';
import Layout from '../Layout';
import { StyledTextField } from '../../Components/CustomTextfield';
import SignUp from './SignUp';
import Login from './Login';
import ProductsBanner from './ProductsBanner';
import {  Il8nContext } from '../../Helper/i18n';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import FullScreenLoader from '../../Components/FullScreenLoader';
import { appStages, getGlobalSteper, Steps } from '../../Helper/AppStepperData';
import { updateStepper } from '../../Helper/Redux/reducers/upDown';
import { WindowSharp } from '@mui/icons-material';
// import { I18nContext } from '../../App'
let isVerified =false
function LandingPage(props) {    
    const { path } = props
    const theme = useTheme();
    const stepper = useSelector(state => state.storeState.stepper)
    const store = useSelector(state => state.storeState.stage)
    const dispatch = useDispatch()
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [responseStatus, setResponseStatus] = useState({})   
    const [enableOtp, setEnableOTP] = useState(false)
    const [loading, setLoading] = useState(false)
    const [loader, setLoader] = useState(false)
    const [isCaptcha, setIsCaptcha] = useState(false)
    const [showProceed, setShowProceed] = useState(false)
    const [timerCaptcha, setTimerCaptcha] = useState(false)
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
    const urlSegments = window.location.href
    const urlParams = new URL(urlSegments).searchParams
    const navigate = useNavigate()
    const localeText = useContext(Il8nContext)
    const googleCaptchaRef = useRef();

    useEffect(()=>{
        getToken(true) && getStageDetails()        
        if (urlParams.get("sb")) {
            setCookie("referalCode", window.atob(urlParams.get("sb")))
        }
        else{
            deleteCookie("referalCode");
            document.cookie = "referalCode=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        }
    }, [])    
    console.log("Steps ::: Landing page",Steps )
    useEffect(()=>{
        if(store.location){
            let values = store.signUpFormData
            handleSubmit("sendOTP", values)
        }
    }, [store.location])
    
    function handleSnackBarClose() {
        setSnackBarOpen(false)
        setResponseStatus()
    }

    const getLatLong = (values) => {
        setEnableOTP(true)
        if (!navigator.geolocation) {
            setResponseStatus({ "message": localeText?.landingGeolocation, "type": "warning" })
            setSnackBarOpen(true)
            console.log("Geolocation is not supported by your browser")
        }
        else {
            navigator.geolocation.getCurrentPosition((position) => {
                getLocationData(position.coords.latitude, position.coords.longitude, values)
            },
                function showError(error) {
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            handleSubmit("sendOTP",values)
                            setResponseStatus({ "message": localeText?.landingGrantPermission, "type": "warning" })
                            setSnackBarOpen(true)
                            console.log("User denied the request for Geolocation.")
                            break;
                        case error.POSITION_UNAVAILABLE:
                            setResponseStatus({ "message": localeText?.landingGeolocation, "type": "warning" })
                            setSnackBarOpen(true)
                            console.log("Geolocation is not supported by your browser.")
                            break;
                        case error.TIMEOUT:
                            setResponseStatus({ "message": localeText?.landingTryAgain, "type": "warning" })
                            setSnackBarOpen(true)
                            console.log("The request to get user location timed out.")
                            break;
                        case error.UNKNOWN_ERROR:
                            setResponseStatus({ "message": localeText?.landingSerrorOccurred, "type": "error" })
                            setSnackBarOpen(true)
                            console.log("An unknown error occurred.")
                            break;
                    }
                }
            )
        }
    }

    const getLocationData = (latitude, longitude, values) => {
        if (latitude && longitude) {
            // setConfirmLocationPopup(false)
            axios.post(process.env.REACT_APP_LOCATION_URL, { latitude, longitude }, { auth: true, headers: { "request-info": '{"rit":"123","cver": "1.0v","ch": "WEB","info":{},"reqts":"12345678","payload":[]}' } })
                .then(response => {
                    console.log("User's Location Info: ", response);
                    dispatch(addStageData({ ...store, location: response.data.success, signUpFormData: values }))

                    // localStorage.setItem("location", JSON.stringify(response.data.success))
                    // handleSubmit("sendOTP", values)
                    // setConfirmLocationPopup(false)
                })
                .catch(status => {
                    console.log('Request failed. Returned status of', status);
                    // store.dispatch(submit("SignUp"))
                })
        } else {
            console.log("User's Location Info: ")
            // setConfirmLocationPopup(false)
            // store.dispatch(submit("SignUp"))
        }

    }

    const getSeoParams = function () {
        let keys = {
            "parm_Browser": { key: "utm_browser" },
            "parm_Device": { key: "utm_device" },
            "parm_LeadGender": { key: "utm_gender" },
            "parm_LeadLocation": { key: "utm_location" },
            "parm_LeadPinCode": { key: "utm_pincode" },
            "parm_LeadCity": { key: "utm_city" },
            "parm_LeadState": { key: "utm_state" },
            "parm_LeadCampaign": { key: "utm_campaign" },
            "parm_Medium": { key: "utm_medium" },
            "parm_AdGroupName": { key: "utm_adgroup" },
            "parm_Creative": { key: "utm_creative" },
            "parm_Keyword": { key: "utm_keyword" },
            "parm_Language": { key: "utm_language" },
            "parm_Banner": { key: "utm_banner" },
            "parm_LeadSource": { key: "utm_source" },
            "parm_LeadProduct": { key: "utm_product" },
            "parm_LeadSubSource": { key: "utm_sub-source" },
            "parm_LeadName": { key: "name" },
            "parm_LeadEmail": { key: "email" }
        }
        let params = window.location.href.split("?")
        if (!params[1]) {
            params[1] = "utm_source=website&utm_sub-source=HP&utm_medium=organic&utm_campaign=initial_Launch&utm_creative=upfronrt&utm_adgroup=&utm_keyword=&utm_device=&utm_gender=&utm_browser=&utm_city=&utm_state=&utm_country=&utm_language=&utm_product"
        }
        let paramArray = params[1].split("&")
        let inputObj = {}
        paramArray.forEach(prm => {
            let p = prm.split("=")
            inputObj[p[0]] = p[1]
        })
        let retObj = {}
        Object.keys(keys).forEach(k => {
            retObj[k] = inputObj[keys[k].key] || ""
        })
        if ("city" in inputObj) {
            retObj["parm_LeadCity"] = atob(inputObj["city"])
        }
        if ("name" in inputObj) {
            retObj["parm_LeadName"] = atob(inputObj["name"])
        }
        if ("email" in inputObj) {
            retObj["parm_LeadEmail"] = atob(inputObj["email"])
        }
        return retObj;
    }

    const allURLParamsArray = () => {
        let a = [];
        for (let key of urlParams.keys()) {
            a.push(key)
        }
        return a;
    }

    const guestLogin =()=>{
        deleteCookie("isEmailMobileVerficationFailed") 
        window.location.href = `${process.env.REACT_APP_LOGIN_URL}${btoa(window.location.origin)}&isRegUser=1`
    }

    const nextNavigation = ()=>{
        navigate("/ThirdParty")
    }

    const getStageDetails = (isSignUpCall) => {
        setLoading(true)
        isSignUpCall && dispatch(addStageData({ ...store, "appStages" : appStages }))
        localStorage.clear()
        localStorage.setItem("appStages", JSON.stringify(appStages))
        axios.get(process.env.REACT_APP_API_URL + config.stageDetails)
            .then(resp => {
                setLoading(false)
                if (resp.data.success) {
                    setCookieNew("referalCode", resp.data.success.subBrokerCode || "")
                    if(isSignUpCall){
                        nextNavigation()
                    }
                    else{
                        if (resp.data.success.stageDetilasList && resp.data.success.stageDetilasList.length > 0) {
                            // if (window['$_REVECHAT_API']) {
                            //     window['$_REVECHAT_API'](function () {
                            //         var details = JSON.parse(atob(getToken(true).split(".")[1]))
                            //         console.log(details)
                            //         window['$_REVECHAT_API'].Form.Online.setEmail(details.email || "");
                            //         window['$_REVECHAT_API'].Form.Online.setContact(details.sub);
                            //         window['$_REVECHAT_API'].Form.Online.setName(details.clientName || "");
                            //         window['$_REVECHAT_API'].Form.Offline.setEmail(details.email || "");
                            //         window['$_REVECHAT_API'].Form.Offline.setContact(details.sub);
                            //         window['$_REVECHAT_API'].Form.Offline.setName(details.clientName || "");
                            //     });
                            // }
    
                            dispatch(addStageData({ ...store, "appStages" : resp.data.success.stageDetilasList }))
                            
                            localStorage.setItem("appStages", JSON.stringify(resp.data.success.stageDetilasList))
                            setCookieNew("referalCode", resp.data.success.subBrokerCode || "")
                            if (resp.data.success.isMF) {
                                // setIsMf(true)
                                dispatch(addStageData({ ...store, "isMF" : true }))
                                // stepperEvent.sendMessage({ rem: true })
                                // store.dispatch(change("SEGMENT", "seg", "MF"))
                            }
                            else {
                                // store.dispatch(change("SEGMENT", "seg", "EQ"))
                            }
                            if (resp.data.success.stageDetilasList[12].status == 1) {
                                localStorage.setItem("POA", "done")
                            }
                            if (resp.data.success.stageDetilasList[10].status == 1 && resp.data.success.stageDetilasList[11].status == 0) {
                                // (data.setNestedStep(0), data.setCurrentStep((resp.data.success.isMF) ? 7 : 8))
                                navigate(resp.data.success.isMF ? "/Courier" : "/Scrutiny");
                                return 
                            } else if (resp.data.success.stageDetilasList[10].status == 1 && resp.data.success.stageDetilasList[11].status == 1 && resp.data.success.stageDetilasList[12].status == 1) {
                                // (data.setNestedStep(0), data.setCurrentStep((resp.data.success.isMF) ? 8 : 9))
                                navigate(resp.data.success.isMF ? "/Scrutiny" : "/Objection");
                                // dispatch(updateStepper({ step: 3, nestedStep: 1 })); // Add Steppers
                                return 
                            }
                            else if (resp.data.success.stageDetilasList[2].status == 1 && resp.data.success.stageDetilasList[9].status == 1 && resp.data.success.stageDetilasList[12].status == 0) {
                                localStorage.setItem("esignStatus", "done")
                                // (data.setNestedStep(0), data.setCurrentStep((resp.data.success.isMF) ? 6 : 7))
                                // dispatch(updateStepper({ step: 3, nestedStep: 1 })); // Add Steppers
                                navigate(resp.data.success.isMF ? "/ESign" : "/Courier");
                                return 
                            } else if (resp.data.success.stageDetilasList[2].status == 1 && resp.data.success.stageDetilasList[9].status == 0 && resp.data.success.stageDetilasList[10].status == 0) {
                                if (resp.data.success.stageDetilasList[12].status == 1){
                                    // setObjection(true)
                                }
                                // (data.setNestedStep(0), data.setCurrentStep((resp.data.success.isMF) ? 4 : 5))
                                navigate(resp.data.success.isMF ? "/Upload" : "/Review");
                                !(stepper?.length) && dispatch(updateStepper(getGlobalSteper(resp.data.success.stageDetilasList)))
                                // dispatch(updateStepper(resp.data.success.isMF ? { step: 3, nestedStep: 3 } : { step: 4, nestedStep: 1 })); 
                                return 
                            }
    
    
                            function modifySteps (mf) {
                                if (mf) {
                                    Steps[1].steps.push({stageCode: "NOMM"})
                                }
                                return Steps
                            }
    
                            const getStep = (response, code) => {
                                const step = response.filter((st) => {return st.stageCode === code})
                                return step[0].status
                            }
    
                            modifySteps(resp.data.success.isMF).forEach((step) => {
                                step.status = getStep(resp.data.success.stageDetilasList, step.stageCode)
                                if (step.steps && step.steps.length > 0) {
                                    step.steps.forEach((ns) => {
                                        ns.status = getStep(resp.data.success.stageDetilasList, ns.stageCode)
                                        if (resp.data.success.isMF && (ns.stageCode == "PAY" || ns.stageCode == "BROK")) {
                                            ns.status = 1
                                        } else if (ns.stageCode == "PAY" && ns.status == 1) {
    
                                        }
                                    })
                                }
                            })
    
                            for (let i = 0; i < Steps.length; i++) {
                                let arr = ["/ThirdParty", "/Profile", "/BankDetails", "/PlanDetails", "/Upload", "/Review", "/Esign", "/Courier", "/Scrutiny", "/Objection"]
                                if (!Steps[i].steps && Steps[i].status === 0) {
                                    if (resp.data.success.isMF && i > 2) {
                                        // let arr = ["/BankDetails", "/Upload", "/Review", "/Esign", "/Courier", "/Scrutiny", "/Objection"]
                                        // (data.setCurrentStep(i - 1))
                                        navigate(arr[i - 1]);
                                        return 
                                    }
                                    navigate(arr[i]);
                                    return                                 
                                }
                                if (Steps[i].steps && Steps[i].steps.length > 0) {
                                    for (let j = 0; j < Steps[i].steps.length; j++) {
                                        if (Steps[i].steps[j].status === 0) {
                                            let nestedStepNavs = {
                                                "PERSO": "/Profile",
                                                "ADD": "/AddressDetails",
                                                "BASIC": "/AddressDetails",
                                                "BROK": "/PlanDetails",
                                                "PAY": "/Payment"
                                            }
                                            if (resp.data.success.isMF && i > 2) {
                                                // (data.setNestedStep(j), data.setCurrentStep(i - 1))
                                                navigate(nestedStepNavs[Steps[i].steps[j].stageCode]);
                                                return 
                                            }
    
                                            navigate(nestedStepNavs[Steps[i].steps[j].stageCode]);
                                            // (data.setNestedStep(j), data.setCurrentStep(i))
                                            return 
                                        }
                                    }
                                }
                            }
    
                        }
                    }
                } else {
                    throw new Error()
                }
            }).catch((err) => {
                setLoading(false)
                isSignUpCall && nextNavigation()
            })
    }
   
    const updateCaptcha = () => {
      googleCaptchaRef?.current?.props?.grecaptcha?.reset();
    };

    const handleSubmit = (callFor, formValues) => {
        deleteCookie("isEmailMobileVerficationFailed") 

        if((callFor == "sendOTP" || callFor == undefined) && !googleCaptchaRef.current?.getValue()){
            setIsCaptcha(true)
            setLoader(false)
            setEnableOTP(false)
            setTimerCaptcha(true)
        }
        else{

            let data = store
            console.log(data)
            let stepOne = true;
            let state = ""
            let stateSh = ""
            let city = ""
            let address = ""
            let country = ""
            let pinCode = ""
            let location = ""
            if (data.location) {
                if (data.location.results) {
                    data.location.results.forEach(item => {
                        if (item.types.includes("locality")) {
                            city = item.address_components[0].long_name
                        } if (item.types.includes("administrative_area_level_1")) {
                            state = item.address_components[0].long_name
                            stateSh = item.address_components[0].short_name
                        } if (item.types.includes("country")) {
                            country = item.address_components[0].long_name
                        } if (item.types.includes("postal_code")) {
                            pinCode = item.address_components[0].long_name
                        } if (item.types.includes("sublocality")) {
                            location = item.address_components[0].long_name
                        }
                    })
                    if (data.location.results[0])
                        address = data.location.results[0].formatted_address
                }
            }
    
            let dataObj = {
                stg: 101,
                captchaResponse: (callFor == "sendOTP" || callFor == undefined) ? googleCaptchaRef.current?.getValue() : undefined,
                mobileNumber: /* "7896541239" ||  */formValues?.mobile?.trim() || data?.mobile?.trim(),
                city : atob(urlParams.get("city") || ""),
                state,
                address,
                stateShortCode: stateSh,
                country,
                pinCode,
                location,
                requestSource: urlParams.get("requestSource") || "",
                googleResp: data.location,
                ...(callFor == "verifyOTP" ? {
                    stg: 102,
                    otpToken: data.otpToken,
                    otp: formValues.otp,
                }
                 : callFor == "sendOTP" ? {
                    "isDigital": !((allURLParamsArray().length == 2 && allURLParamsArray().find(item => item == "mobile") && allURLParamsArray().find(item => item == "sb")) || getCookie("referalCode")),
                    "isOTP": true,
                } : {
                    "isDigital": !((allURLParamsArray().length == 2 && allURLParamsArray().find(item => item == "mobile") && allURLParamsArray().find(item => item == "sb")) || getCookie("referalCode")),
                    "isOTP": false,
                }),
                /* "referalCode":getCookie("referalCode")||"", */
                "seo": getSeoParams()
            }
            dataObj.seo.parm_SubBrokerCode = getCookie("referalCode")
            dataObj.seo.parm_LeadCity = city || dataObj.seo.parm_LeadCity
            dataObj.seo.parm_LeadState = state || dataObj.seo.parm_LeadState
            dataObj.seo.parm_LeadAddress = address
            dataObj.seo.parm_LeadStateShortCode = stateSh
            dataObj.seo.parm_LeadCountry = country
            dataObj.seo.parm_LeadPinCode = pinCode
            dataObj.seo.parm_LeadLocation = location || dataObj.seo.parm_LeadLocation
            if ((callFor == "verifyOTP" && urlParams.get("mobile") && urlParams.get("otpToken"))){
                dataObj["clientName"] = atob(urlParams.get("name") || "")
                dataObj["emailID"] =  " "
                dataObj["mobileNumber"] =formValues?.mobile?.trim() || data?.mobile?.trim()
            }
            else if ((callFor == "signupSubmit")) {
                stepOne = false
                dataObj = {
                    stg: 103 ,
                    clientName: formValues?.name?.trim() || "",
                    emailID: formValues?.email?.trim() || " ",
                    mobileNumber: /* "7896541239" ||  */formValues?.mobile?.trim() || data?.mobile?.trim(),
                    //channelID: "2",
                    //channel : "WEB",
                    // mACAddress: " 00:00:00:a1:2b:cc",
                    password: formValues?.confirmPassword,
                    "seo": getSeoParams()
                }
            }
    
            if (callFor !=="noCall"){
                axios.post(process.env.REACT_APP_API_URL + config.verifySignup , dataObj)
                .then(resp => {
                    if (resp.data.success) {
                        if (callFor == "sendOTP") {
                            setResponseStatus({ "message": resp.data.success, "type": "success" })
                            setSnackBarOpen(true)
                            dispatch(addStageData({ ...store, otpToken: resp.data.otpToken }))
                            setEnableOTP(true)
                            setShowProceed(true)
                            isVerified=true
                            setTimerCaptcha(false)
                            setTimeout(updateCaptcha, 200);
                          }
                        else if (callFor == "verifyOTP") {
                            // dispatch(addStageData({ ...store, page: "signUp" }))
                            // window.open(`${window.location.origin}${"/SignUp"}`, "_self")
                            if(callFor == "verifyOTP" && resp?.data?.success?.access_token && resp?.data?.success?.refresh_token){
                            setTokens(resp.data.success.access_token, resp.data.success.refresh_token)
                            var tkDetail = JSON.parse(atob(resp.data.success.access_token.split(".")[1]))
                            setTimeout(tokenReInitializer.bind(null, tkDetail.exp - tkDetail.iat - 100), (tkDetail.exp - tkDetail.iat - 100) * 1000)
                            tokenReInitializer();  
                            getStageDetails()
                            }
                            else{
                                navigate("/SignUp")
                            }                       
                        }
                        else if (callFor == "signupSubmit") {
                            setTokens(resp.data.success.access_token, resp.data.success.refresh_token)
        
                            var tkDetail = JSON.parse(atob(resp.data.success.access_token.split(".")[1]))
                            setTimeout(tokenReInitializer.bind(null, tkDetail.exp - tkDetail.iat - 100), (tkDetail.exp - tkDetail.iat - 100) * 1000)
                            tokenReInitializer();  
                            getStageDetails(true)
                        }
                        setLoader(false)
                    }
                    else {
                        setLoader(false)
                        // setEnableOTP(true)
                        setEnableOTP(false)
                        throw new Error(resp.data.error.msg)
                    }
                }).catch((error) => {
                    if(callFor == "sendOTP" || callFor == undefined){
                      setTimeout(updateCaptcha, 200);
                    }
                    // data.setError(error.message)
                    setResponseStatus({ "message": error.message, "type": "error" })
                    setSnackBarOpen(true)
                })
            }
            else{
                setResponseStatus({ "message": "Enter OTP sent on mobile number.", "type": "success" })
                setSnackBarOpen(true)
                dispatch(addStageData({ ...store, otpToken: urlParams.get("otpToken") }))
                setEnableOTP(true)
            }
        }
    }

    return (
        // <I18nContext.Consumer>
        loading ? <FullScreenLoader />
            : <Layout hideSidebarGrid withOutSidebar hideLogoutIcon>
                <Grid container css={{height:"100%", width:"100%", borderRadius:"30px", zIndex:"1"}} >
                    <Grid container item direction={isSmallScreen ? "column-reverse" : "row"}
                        css={{ height: "auto", width: "100%", background: "#FFFFFF", borderRadius: isSmallScreen ? "30px" : "30px 30px 0px 0px", boxShadow: "0px 0px 6px #00000017" }}
                        justifyContent="center"
                        alignItems="flex-start"
                    >
                        <Grid container md={6} item alignItems="center" justifyContent="center" css={{ padding: "50px 30px" }} >
                            <Grid container item justifyContent="center">
                                <Typography css={{ fontWeight: "bold", lineHeight: isSmallScreen ? "" : "50px", fontSize: isSmallScreen ? "20px" : "40px", color: "#525D72", textAlign: "center" }}>
                                    {localeText?.landingTranding}
                                </Typography>
                                &nbsp;
                                &nbsp;
                                <Typography css={{ fontWeight: "bold", lineHeight: isSmallScreen ? "" : "50px", fontSize: isSmallScreen ? "20px" : "40px", color: "#24B7CC", textAlign: "center" }}>
                                    {localeText?.landingDigital}
                                </Typography>
                            </Grid>
                            <Grid container item justifyContent="space-evenly" alignItems={"end"}>
                                <Grid item xs={8} md={9}>
                                    <img src="/images/TB_Pro.svg" alt="Tradebulls Pro" css={{ height: isSmallScreen ? "auto" : "230px", width: isSmallScreen ? "100%" : "100%" /* "370px" */ }} />
                                </Grid>
                                <Grid item xs={4} md={3}>
                                    <img src="/images/tb_touch.svg" alt="Tradebulls Touch" css={{ height: isSmallScreen ? "auto" : "260px", width: isSmallScreen ? "100%" : "100%" /* "150px" */ }} />
                                </Grid>
                            </Grid>
                        </Grid>

                        {(/* store.page !== "signUp" ||  */ !path || path == "/Login") &&
                            <Login googleCaptchaRef={googleCaptchaRef} urlParams={urlParams} getLatLong={getLatLong} handleSubmit={handleSubmit} enableOtp={enableOtp} guestLogin={guestLogin} loader={loader} setLoader={setLoader} isCaptcha={isCaptcha} setIsCaptcha={setIsCaptcha} showProceed={showProceed} setShowProceed={setShowProceed} timerCaptcha={timerCaptcha} setTimerCaptcha={setTimerCaptcha} isVerified={isVerified}
                            />
                        }

                        {(/* store.page == "signUp" || */ path == "/SignUp") &&
                            <SignUp urlParams={urlParams} handleSubmit={handleSubmit}  loader={loader} setLoader={setLoader}/>
                        }
                    </Grid>

                    {!isSmallScreen &&
                        <ProductsBanner />
                    }
                </Grid>

                {
                    responseStatus && responseStatus.message && <Snackbar
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                            zIndex: '101',
                        }}
                        open={snackBarOpen}
                        autoHideDuration={5000}
                        onClose={handleSnackBarClose}
                    >
                        <MySnackbarContentWrapper
                            onClose={handleSnackBarClose}
                            variant={responseStatus.type}
                            message={responseStatus.message}
                        />
                    </Snackbar>
                }
            </Layout>
        // </I18nContext.Consumer>
    );
}



export default LandingPage;